import { Link, useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../App";
import useInvoke from "../Tools/Invoker";
import DynamicGrid from "../Tools/DynamicGrid";
import LoginRedirect from "../Page/LoginRedirect";
import CheckToken from "../_Login/CheckToken";
import toast, { Toaster } from 'react-hot-toast';
import CountrySave from "./CountrySave";


const CountryNew = () => {

    const [user, setUser] = useContext(UserContext);
    let navigate = useNavigate();
    CheckToken(user["id"], user["token"]).then((result) => {if(!result) {setUser({}); navigate("/Login");}});

    const handleFormSubmit = (e) => {

        let countryid = "";
        
        let valid = true;

        let countryname = "";        
        if (document.getElementById("country").value != "") {
            countryname = document.getElementById("country").value;
        }
        else {
            valid = false; 
            toast.error("Country Name required");
        }

        let countryabbr = "";
        if (document.getElementById("abbr").value != "") {
            countryabbr = document.getElementById("abbr").value;
        }
        else {
            valid = false; 
            toast.error("Country Abbr required");
        }

        let modifiedbyid = user["id"];
        let deleted = "0";
        
        if (valid) { 
            CountrySave(countryid, countryname, countryabbr, modifiedbyid, deleted);
            toast.success('Success');
            navigate("/Country");
        }
    };
    
    document.title = "Country - New";
    return ( 
        <div className="countryNew">
            {user["email"] != undefined &&
                <>
                    <div className="container body-content" style={{marginTop: "25px"}}>
                            
                        <h2>New Country</h2>

                        <form id="countryForm" noValidate="novalidate" autoComplete="off">  

                            <div className="form-group">
                                <label htmlFor="country">Country</label>
                                <input className="form-control" id="country" name="country" type="text" value="" autocomplete="off" />
                            </div>

                            <div className="form-group">
                                <label htmlFor="abbr">Abbr</label>
                                <input className="form-control" id="abbr" name="abbr" type="text" value="" autocomplete="off" />
                            </div>
                        </form> 
                        <Link to="/Country" className="btn btn-default" style={{marginRight: "4px"}}>Cancel</Link>                           
                        <button onClick={handleFormSubmit} className="btn btn-primary" style={{marginRight: "4px"}}>Save</button>                        
                    </div>
                </>
            }
        </div>
     );
}
 
export default CountryNew;